<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Clock In</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>

    <form [formGroup]="attendaceForm" #myForm="ngForm" (ngSubmit)="attendaceFormSubmit()">

        <mat-form-field>
            <mat-label>Working on</mat-label>
            <textarea cols="35" formControlName="working_on" rows="1" matInput autofocus></textarea>
            <mat-error *ngIf="attendaceFormValidate?.working_on?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue">Confirm </button>
            </div>
        </div>
    </form>
</div>